export default __webpack_public_path__ + "static/media/283.376c12db.png";